import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { formatAmount } from "../../Utility/functions/Helper";
import { sportEndPoint } from "../../constant/Environment";
import { addBetData } from "../../Utility/API";

const BetslipPayout = ({ betslipLength, wager, samesport, multiplier,onPayoutUpdate }) => {
  let payoutDetail = [];

  const[payoutvalues,setPayoutvalues] = useState([]);

  const getPercentage = (part, total, multiplier) => {
  let result = (part / total) * 100;
  let finalResult = (multiplier * result) / 100;
  return Math.ceil(finalResult * 100) / 100.0;
};


  function getMinCorrect(betslipLength, samesport) {
  switch (betslipLength) {
    case 2:
      return 2;

    case 3:
      return samesport ? 3 : 3; // both cases need 3 correct

    case 4:
      return 3; // regardless of samesport

    case 5:
      return 4; // regardless of samesport

    case 6:
      return samesport ? 5 : 4;

    case 7:
      return 5;

    case 8:
      return 6;

    case 9:
      return 7;

    case 10:
      return 8;

    default:
      return null;
  }
}

  // if (multiplier) {
  //   if (betslipLength === 2) {
  //     payoutDetail.push({ players: 2, amount: wager * multiplier });

  //   } else if (betslipLength === 3 && !samesport) {
  //     payoutDetail.push({ players: 3, amount: wager * multiplier });

  //   } else if (betslipLength === 3 && samesport) {
  //     payoutDetail.push({ players: 3, amount: wager * getPercentage(2.25, 4, multiplier) });

  //   } else if (betslipLength === 4 && !samesport) {
  //     payoutDetail.push({ players: 4, amount: wager * multiplier });
  //     payoutDetail.push({ players: 3, amount: wager * getPercentage(1, 5, multiplier) });

  //   } else if (betslipLength === 4 && samesport) {
  //     payoutDetail.push({ players: 4, amount: wager * getPercentage(4, 5, multiplier) });
  //     payoutDetail.push({ players: 3, amount: wager * getPercentage(1, 5, multiplier) });

  //   } else if (betslipLength === 5 && !samesport) {
  //     payoutDetail.push({ players: 5, amount: wager * multiplier });
  //     payoutDetail.push({ players: 4, amount: wager * getPercentage(1.25, 10, multiplier) });

  //   } else if (betslipLength === 5 && samesport) {
  //     payoutDetail.push({ players: 5, amount: wager * getPercentage(7, 10, multiplier) });
  //     payoutDetail.push({ players: 4, amount: wager * getPercentage(1, 10, multiplier) });

  //   } else if (betslipLength === 6 && !samesport) {
  //     payoutDetail.push({ players: 6, amount: wager * multiplier });
  //     payoutDetail.push({ players: 5, amount: wager * getPercentage(2, 25, multiplier) });
  //     payoutDetail.push({ players: 4, amount: wager * getPercentage(0.5, 25, multiplier) });

  //   } else if (betslipLength === 6 && samesport) {
  //     payoutDetail.push({ players: 6, amount: wager * getPercentage(12, 25, multiplier) });
  //     payoutDetail.push({ players: 5, amount: wager * getPercentage(1.5, 25, multiplier) });
  //     payoutDetail.push({ players: 4, amount: 0.0 });

  //   } else if (betslipLength === 7) {
  //     payoutDetail.push({ players: 7, amount: wager * multiplier });
  //     payoutDetail.push({ players: 6, amount: wager * getPercentage(4, 40, multiplier) });
  //     payoutDetail.push({ players: 5, amount: wager * getPercentage(0.75, 40, multiplier) });

  //   } else if (betslipLength === 8) {
  //     payoutDetail.push({ players: 8, amount: wager * multiplier });
  //     payoutDetail.push({ players: 7, amount: wager * getPercentage(5, 60, multiplier) });
  //     payoutDetail.push({ players: 6, amount: wager * getPercentage(1, 60, multiplier) });

  //   } else if (betslipLength === 9) {
  //     payoutDetail.push({ players: 9, amount: wager * multiplier });
  //     payoutDetail.push({ players: 8, amount: wager * getPercentage(6, 80, multiplier) });
  //     payoutDetail.push({ players: 7, amount: wager * getPercentage(1, 80, multiplier) });

  //   } else if (betslipLength === 10) {
  //     payoutDetail.push({ players: 10, amount: wager * multiplier });
  //     payoutDetail.push({ players: 9, amount: wager * getPercentage(7, 125, multiplier) });
  //     payoutDetail.push({ players: 8, amount: wager * getPercentage(1.5, 125, multiplier) });
  //   }
  // }

  const minBetCorrect = (payoutvalues.length) - 1;

   const BetPayout = async (betslipLength,wager,samesport,multiplier) => {
         let url =  `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.BET_PAYOUT}`;
         let data = {    
             sameTeam: samesport,
             wager: wager || 0,
             multiplier: multiplier,
             totalPlayers: betslipLength,
         };
         try {
           let response = await addBetData(url, data);
           if(response.status == 202 ){
              setPayoutvalues(response.data);
           }
           if (onPayoutUpdate) {
              onPayoutUpdate(response.data);
        }
           else{
           }
     
         } catch (err) {
           console.log('err',err)
        }
       }; 
   
       useEffect(()=>{
        BetPayout(betslipLength,wager,samesport,multiplier);
       },[wager,betslipLength,multiplier,samesport])

  if (multiplier) {
  if (betslipLength === 2) {
    payoutDetail.push({
      players: 2,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });

  } else if (betslipLength === 3 && !samesport) {
    payoutDetail.push({
      players: 3,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });

  } else if (betslipLength === 3 && samesport) {
    const multi = getPercentage(2.25, 4, multiplier);
    payoutDetail.push({
      players: 3,
      amount: wager * multi,
      multiplierUsed: multi,
    });

  } else if (betslipLength === 4 && !samesport) {
    payoutDetail.push({
      players: 4,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });
    const multi3 = getPercentage(1, 5, multiplier);
    payoutDetail.push({
      players: 3,
      amount: wager * multi3,
      multiplierUsed: multi3,
    });

  } else if (betslipLength === 4 && samesport) {
    const multi4 = getPercentage(4, 5, multiplier);
    const multi3 = getPercentage(1, 5, multiplier);
    payoutDetail.push({
      players: 4,
      amount: wager * multi4,
      multiplierUsed: multi4,
    });
    payoutDetail.push({
      players: 3,
      amount: wager * multi3,
      multiplierUsed: multi3,
    });

  } else if (betslipLength === 5 && !samesport) {
    payoutDetail.push({
      players: 5,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });
    const multi4 = getPercentage(1.25, 10, multiplier);
    payoutDetail.push({
      players: 4,
      amount: wager * multi4,
      multiplierUsed: multi4,
    });

  } else if (betslipLength === 5 && samesport) {
    const multi5 = getPercentage(7, 10, multiplier);
    const multi4 = getPercentage(1, 10, multiplier);
    payoutDetail.push({
      players: 5,
      amount: wager * multi5,
      multiplierUsed: multi5,
    });
    payoutDetail.push({
      players: 4,
      amount: wager * multi4,
      multiplierUsed: multi4,
    });

  } else if (betslipLength === 6 && !samesport) {
    payoutDetail.push({
      players: 6,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });
    const multi5 = getPercentage(2, 25, multiplier);
    const multi4 = getPercentage(0.5, 25, multiplier);
    payoutDetail.push({
      players: 5,
      amount: wager * multi5,
      multiplierUsed: multi5,
    });
    payoutDetail.push({
      players: 4,
      amount: wager * multi4,
      multiplierUsed: multi4,
    });

  } else if (betslipLength === 6 && samesport) {
    const multi6 = getPercentage(12, 25, multiplier);
    const multi5 = getPercentage(1.5, 25, multiplier);
    payoutDetail.push({
      players: 6,
      amount: wager * multi6,
      multiplierUsed: multi6,
    });
    payoutDetail.push({
      players: 5,
      amount: wager * multi5,
      multiplierUsed: multi5,
    });
    payoutDetail.push({
      players: 4,
      amount: 0.0,
      multiplierUsed: 0.0,
    });

  } else if (betslipLength === 7) {
    const multi6 = getPercentage(4, 40, multiplier);
    const multi5 = getPercentage(0.75, 40, multiplier);
    payoutDetail.push({
      players: 7,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });
    payoutDetail.push({
      players: 6,
      amount: wager * multi6,
      multiplierUsed: multi6,
    });
    payoutDetail.push({
      players: 5,
      amount: wager * multi5,
      multiplierUsed: multi5,
    });

  } else if (betslipLength === 8) {
    const multi7 = getPercentage(5, 60, multiplier);
    const multi6 = getPercentage(1, 60, multiplier);
    payoutDetail.push({
      players: 8,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });
    payoutDetail.push({
      players: 7,
      amount: wager * multi7,
      multiplierUsed: multi7,
    });
    payoutDetail.push({
      players: 6,
      amount: wager * multi6,
      multiplierUsed: multi6,
    });

  } else if (betslipLength === 9) {
    const multi8 = getPercentage(6, 80, multiplier);
    const multi7 = getPercentage(1, 80, multiplier);
    payoutDetail.push({
      players: 9,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });
    payoutDetail.push({
      players: 8,
      amount: wager * multi8,
      multiplierUsed: multi8,
    });
    payoutDetail.push({
      players: 7,
      amount: wager * multi7,
      multiplierUsed: multi7,
    });

  } else if (betslipLength === 10) {
    const multi9 = getPercentage(7, 125, multiplier);
    const multi8 = getPercentage(1.5, 125, multiplier);
    payoutDetail.push({
      players: 10,
      amount: wager * multiplier,
      multiplierUsed: multiplier,
    });
    payoutDetail.push({
      players: 9,
      amount: wager * multi9,
      multiplierUsed: multi9,
    });
    payoutDetail.push({
      players: 8,
      amount: wager * multi8,
      multiplierUsed: multi8,
    });
  }
}

  return (
    <div
      className="payoutbox p-2 mb-2"
      style={{
        border: "2px solid #0D3862",
        borderRadius: "15px",
        marginBottom: "5px",
        backgroundColor: "#f8f9fa"
      }}
    >
      <Row className="payoutrow">
        <Col lg={12} style={{ marginBottom: "4px" }}>
          <h6>
            You must at least get {payoutvalues[minBetCorrect]?.players}{" "}
            player selections correct to qualify for a payout
          </h6>
        </Col>

        {payoutvalues?.map((tier, index) => (
          <React.Fragment key={index}>
            <Col lg={4} xs={4}>
              <h6 style={{ fontWeight: "600" }}>{tier?.players} Correct</h6>
            </Col>
            <Col lg={4} xs={4} className="times">
              <p style={{textAlign:"initial"}}>{`${tier?.multiplier?.toFixed(2)}X`}</p>
            </Col>
            <Col lg={4} xs={4} className="amount">
              <p style={{textAlign:"initial"}}>${formatAmount(tier?.amount?.toFixed(2))}</p>
            </Col>
          </React.Fragment>
        ))}
      </Row>
    </div>
  );
};

export default BetslipPayout;
